import { User } from 'lucide-react';
import { useUserThumbnailSrc } from '../useUserThumbnailSrc';
import './UserListPhoto.css';

type UserListPhotoBaseProps = {
  initials: string;
  className?: string;
};

type UserListPhotoThumbnailProps = UserListPhotoBaseProps & {
  thumbnail?: Blob | string | null;
};

export type TenantUserListPhotoProps = UserListPhotoThumbnailProps;
export type LacUserListPhotoProps = UserListPhotoThumbnailProps;

function UserListPhotoDisplay({
  photoSrc,
  initials,
  className,
}: UserListPhotoBaseProps & {
  photoSrc: string | null;
}) {
  return (
    <div
      className={['user-list-photo', className].filter(Boolean).join(' ')}
      aria-hidden
    >
      {photoSrc ? (
        <img className="user-list-photo__image" src={photoSrc} alt="" />
      ) : initials ? (
        <span className="user-list-photo__initials">{initials}</span>
      ) : (
        <User
          className="user-list-photo__placeholder"
          strokeWidth={1.75}
          aria-hidden
        />
      )}
    </div>
  );
}

export function TenantUserListPhoto({
  thumbnail,
  initials,
  className,
}: TenantUserListPhotoProps) {
  const photoSrc = useUserThumbnailSrc(thumbnail);
  return (
    <UserListPhotoDisplay
      photoSrc={photoSrc}
      initials={initials}
      className={className}
    />
  );
}

export function LacUserListPhoto({
  thumbnail,
  initials,
  className,
}: LacUserListPhotoProps) {
  const photoSrc = useUserThumbnailSrc(thumbnail);
  return (
    <UserListPhotoDisplay
      photoSrc={photoSrc}
      initials={initials}
      className={className}
    />
  );
}
